import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController } from 'ionic-angular';

import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { LoadingAlertProvider } from '../../providers/loading-alert/loading-alert';
import { LoginFlowPage } from '../flows/login-flow/login-flow';
import { UserProvider } from '../../providers/user/user';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  phone: string;
  mask = [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];

  constructor(
    navCtrl: NavController,
    private modalCtrl: ModalController,
    private analytics: AnalyticsProvider,
    private userService: UserProvider,
    private loadingAlert: LoadingAlertProvider
  ) {}

  // View Cycle

  ionViewDidLoad() {
    this.analytics.trackView('LoginPage');
  }

  // Validation

  phoneValidates() {
    return this.phone && this.phone.length == 14;
  }

  // Actions

  didTapGo() {
    if (!this.phone) return;
    let phone = this.phone
      .replace('(', '')
      .replace(')', '')
      .replace(' ', '')
      .replace('-', '');

    this.loadingAlert.showLoader();
    this.userService
      .sendPin(phone)
      .finally(() => this.loadingAlert.dismissLoader())
      .subscribe(
        data => {
          this.showLogin(phone);
        },
        error => {
          // TODO: Check for account exists error
          this.loadingAlert.showToastAlert('User not found');
        }
      );
  }

  showLogin(phone) {
    let modal = this.modalCtrl.create(LoginFlowPage, {
      modal: true,
      phone: phone,
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts